import { render, staticRenderFns } from "./HolidayEdit.vue?vue&type=template&id=0090e4cc"
import script from "./HolidayEdit.js?vue&type=script&lang=js&external"
export * from "./HolidayEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports